import * as util from "./util.js";
import * as ui from "./ui.js";
//argh! I hate doing this! but necassary!
//core data 'structures' are actually embedded in typed arrays. . . ger

//write system for *global* config values!

const _legacy_config_keys = [
  "MODE",
  "SPH_SPEED",
  "SPH_EXP",
  "SPH_MUL",
  "SPH_FILTERWID",
  "DIMEN",
  "DRAW_RMUL",
  "SCALE",
  "PANX",
  "PANY",
  "DISTANCE_LIMIT",
  "HIEARCHIAL_SCALE",
  "HIEARCHIAL_LEVELS",
  "DRAW_RESTRICT_LEVEL",
  "STEPS",
  "QUALITY_STEPS",
  "SMALL_MASK",
  "XLARGE_MASK",
  "QUALITY_STEPS",
  "ALLOW_OVERDRAW",
  "GEN_CMYK_MASK",
  "DRAW_HISTOGRAM",
  "DRAW_OFFS",
  "FFT_TARGETING",
  "DRAW_KDTREE",
  "DRAW_MASK",
  "SCAN_MODE",
  "HIEARCHIAL_SCALE",
  "HIEARCHIAL_LEVELS",
  "TILABLE",
  "LIMIT_DISTANCE",
  "USE_MERSENNE",
  "DRAW_TILED",
  "DISPLAY_TILED",
  "NO_COLOR",
  "USE_TONE_CURVE",
  "DRAW_GRID",
  "DRAW_COLOR",
  "DRAW_GEN",
  "DRAW_ALL_MASKS",
  "TOTMASK",
  "CURRENT_MASK",
  "RELAX_SPEED",
];

window.DEV_MODE = false;
window.APP_VERSION = 0.5;

window.MAX_REPORT_LINES = 12;

//make sure to keep in sync with list in generators.js

window.MODES = {
  /*  SMOOTHMASK   : 0,
  DART         : 1,
  VOID_CLUSTER : 2,
  DART2        : 3,
  MITCHELL     : 4,
  MASKOPT      : 5,
  BLUEVC       : 6,
  SPH          : 7,
  VOID_CLUSTER_CMYK : 8*/
};

window.MODE = 2; //void cluster

window.DRAW_GRID = false;
window.MODE = MODES.DART;
window.VOID_HEX_MODE = false;
window.TEST_CLUSTER = false;
window.RELAX_SPEED = 1.0;

//small offset to signal that a pixel isn't blank in expanded/large masks.
//didn't want to use alpha for it.
window.LARGE_MASK_NONZERO_OFFSET = 1;

window.CMYK = [
  [0, 1, 1],
  [1, 0, 1],
  [1, 1, 0],
  [0, 0, 0],
];

window.ALIGN_GRID = false;
window.VOID_BAYER_MODE = false;

const MAX_BIN = 128;
//points, if PR is < 0 then point is dead
const PointRecord = {
  PX: 0,
  PY: 1,
  PR: 2,
  PGEN: 3,
  PDX: 4,
  PDY: 5,
  PR2: 6,
  PD: 7,
  PIX: 8,
  PIY: 9,
  PCLR: 10,
  PFLAG: 11,
  POLDX: 12,
  POLDY: 13,
  POFFX: 14,
  POFFY: 15,
  POX: 16,
  POY: 17,
  POGEN: 18,
  PMASK: 19,
  PTOT: 20,
};
//put in global namespace
for (const k in PointRecord) {
  window[k] = (PointRecord as Record<string, number>)[k];
}

window.DRAW_OFFS = false;
window.DRAW_HISTOGRAM = true;
window.SPH_CURVE = undefined;
window.TONE_CURVE = undefined;
window.USE_TONE_CURVE = true;
window.RADIUS_CURVE = undefined;
window.VOIDCLUSTER_CURVE = undefined;
window.FFT_CURVE = undefined;

window.FFT_TARGETING = false;

window.GEN_MASK = true;
window.GEN_CMYK_MASK = false;

window.DISPLAY_TILED = true;
window.NO_COLOR = false;
window.ALLOW_OVERDRAW = false;

window.SPH_SPEED = 1.0;
window.SPH_EXP = 2.2;
window.SPH_MUL = 1.0;
window.SPH_FILTERWID = 7.5;

window.DIMEN = 50;

window.DRAW_RMUL = 0.5;
window.DRAW_COLOR = false;
window.DRAW_GEN = false;

window.SCALE = 0.5;
window.PANX = 0.0;
window.PANY = 0.0;
window.DRAW_KDTREE = false;
window.DRAW_MASK = true;
window.SCAN_MODE = false;

window.TILABLE = true;

window.LIMIT_DISTANCE = false;
window.DISTANCE_LIMIT = 0.15;
window.DRAW_ALL_MASKS = false;
window.CURRENT_MASK = 0;
window.TOTMASKS = 1;

window.HIEARCHIAL_SCALE = 9.5;
window.HIEARCHIAL_LEVELS = 8;

window.USE_MERSENNE = true;

Math._random = Math.random;
Math.random = function () {
  if (USE_MERSENNE && window._util) {
    return _util.random();
  } else {
    return Math._random();
  }
};

window.DRAW_RESTRICT_LEVEL = 1;
window.DRAW_TILED = false;

window.SMALL_MASK = true;
window.XLARGE_MASK = false;

window.STEPS = 760;
window.QUALITY_STEPS = 8;

window._search_offs = new Array(64);
_search_offs[0] = [];

//helper offsets for making pointsets tilable
window._poffs = [
  [0, 0],

  [-1, -1],
  [-1, 0],
  [-1, 1],

  [0, 1],
  [1, 1],
  [1, 0],

  [1, -1],
  [0, -1],
];

const save = function () {
  const ret: Record<string, unknown> = {};

  for (const cfg of _configs) {
    for (const k in cfg) {
      ret[k] = window[k];
    }
  }

  for (const k of _legacy_config_keys) {
    ret[k] = window[k];
  }

  return ret;
};
const load = function (obj: Record<string, unknown>) {
  for (const k in obj) {
    let v = obj[k];

    if (ui.Curve.isJSONCurve(v)) {
      const curve = new ui.Curve("");
      curve.loadJSON(v);
      v = curve;

      console.log("found curve", k, v);
    }

    window[k] = v;
  }
};

interface CurveJSON {
  // Legacy single-curve format uses points+eidgen; the newer multi-generator
  // format uses `generators` (surfaced via the index signature) instead, so both
  // are optional here.
  points?: Array<{
    0: number;
    1: number;
    eid: number;
    flag: number;
    deg: number;
    tangent: number;
  }>;
  deg?: number;
  eidgen?: { _cur: number };
  // curve presets also carry assorted metadata (is_new_curve, setting_id,
  // generators, ...); model that openly rather than enumerating every key.
  [key: string]: unknown;
}

var _configs: object[] = [];
const DefaultCurves: Record<string, CurveJSON> = {};
const EditableCurve = class EditableCurve {
  uiname: string;
  default_json: CurveJSON | undefined;

  constructor(uiname: string, default_json?: CurveJSON) {
    this.uiname = uiname;
    this.default_json = default_json;
  }
};
//note: don't call this directly, call interface.MaskConfig.registerConfig!
const registerConfig = function (
  cfg: Record<string, unknown>,
  MaskConfigCls: { registerCurve(key: string, json: unknown): void }
) {
  _configs.push(cfg);

  //need to refactor config system
  for (const k in cfg) {
    let v = cfg[k];

    if (v instanceof EditableCurve) {
      if (v.default_json !== undefined) {
        console.log("Registering curve", k);

        DefaultCurves[k] = v.default_json;
        MaskConfigCls.registerCurve(k, v.default_json);
      }

      v = undefined; //XXX should spawn a curve here, but need to split curve base code out of ui.js first
    }

    if (!(k in window)) {
      window[k] = v;
    }
  }
};

function gen_soff_variants(soff: number[][]): number[][][] {
  const steps = 16;
  const hash: Record<string, number[][]> = {};

  function shuffle(lst: number[][]) {
    for (let i = 0; i < lst.length; i++) {
      const ri = ~~(Math.random() * lst.length * 0.999999);
      const t = lst[ri];

      lst[ri] = lst[i];
      lst[i] = t;
    }
  }

  for (let i = 0; i < soff.length; i++) {
    const ix = soff[i][0];
    const iy = soff[i][1];
    const dis = ix * ix + iy * iy;

    if (!(dis in hash)) {
      hash[dis] = [];
    }

    var lvl = hash[dis];
    lvl.push([ix, iy]);
  }

  const ret = [];

  for (let si = 0; si < steps; si++) {
    const lst = [];

    for (const k in hash) {
      var lvl = hash[k];

      //don't shuffle base level
      if (si > 0) {
        shuffle(lvl);
      }

      for (let j = 0; j < lvl.length; j++) {
        lst.push(lvl[j]);
      }
    }

    lst.sort(function (a, b) {
      return a[0] * a[0] + a[1] * a[1] - b[0] * b[0] - b[1] * b[1];
    });

    ret.push(lst);
  }

  return ret;
}

const get_searchoff_norand = function get_searchoff_norand(
  n: number,
  noreport?: boolean
): number[][] {
  if (_search_offs[n] != undefined) {
    const variants = _search_offs[n];
    return variants[0];
  }

  get_searchoff(n, noreport);

  return _search_offs[n][0];
};
const get_searchoff = function get_searchoff(n: number, noreport?: boolean): number[][] {
  const r = n;
  const i = n;

  if (_search_offs.length <= n) {
    _search_offs.length = n + 1;
  }

  if (_search_offs[n] != undefined) {
    const variants = _search_offs[n];
    const ri = ~~(Math.random() * variants.length * 0.99999);

    return variants[ri];
  }

  if (!noreport) {
    //  console.trace("generate search a off of radius", n, "...");
  }

  const lst = [];
  for (let x = -i; x <= i; x++) {
    for (let y = -i; y <= i; y++) {
      const x2 = x < 0 ? x + 1 : x;
      const y2 = y < 0 ? y + 1 : y;
      let dis = x2 * x2 + y2 * y2;
      dis = dis != 0.0 ? Math.sqrt(dis) : 0.0;

      //console.log(dis.toFixed(3), r.toFixed(3));

      if (dis > r) {
        continue;
      }

      lst.push([x, y]);
    }
  }

  //sort by distance
  lst.sort(function (a, b) {
    return a[0] * a[0] + a[1] * a[1] - b[0] * b[0] - b[1] * b[1];
  });

  _search_offs[n] = gen_soff_variants(lst);

  return get_searchoff(n);
};

window.gen_soff_variants = gen_soff_variants;

for (let i = 0; i < 16; i++) {
  get_searchoff(i, true);
}

export {
  get_searchoff_norand,
  get_searchoff,
  save,
  load,
  _configs,
  DefaultCurves,
  EditableCurve,
  registerConfig,
};
